import { createContext, useContext, useReducer } from "react";
import { filterReducer } from "../reducers/filterReducers";

const filterInitialState = {
    productList: [],
    onlyInStock: false,
    bestSellerOnly: false,
    sortBy: null,
    ratings: null,
};

const FilterContext = createContext(filterInitialState);

export const FilterProvider = ({ children }) => {
    const [state, dispatch] = useReducer(filterReducer, filterInitialState);

    function initialProductList(products) {
        dispatch({
            type: "PRODUCT_LIST",
            payload: { products },
        });
    }

    function bestSeller(products) {
        const filteredProducts = state.bestSellerOnly ? products.filter(product => product.bestSeller) : products;
        return filteredProducts;
    }

    function inStock(products) {
        const filteredProducts = state.onlyInStock ? products.filter(product => product.inStock) : products;
        return filteredProducts;
    }

    function sort(products) {
        let sortedProducts = products;
        if (state.sortBy === "lowtohigh") {
            sortedProducts = products.sort((a, b) => a.price - b.price);
        }
        if (state.sortBy === "hightolow") {
            sortedProducts = products.sort((a, b) => b.price - a.price);
        }
        return sortedProducts;
    }

    function rating(products) {
        let ratedProducts = products;
        if (state.ratings === "4STARSABOVE") {
            ratedProducts = products.filter(product => product.rating >= 4);
        }
        if (state.ratings === "3STARSABOVE") {
            ratedProducts = products.filter(product => product.rating >= 3);
        }
        if (state.ratings === "2STARSABOVE") {
            ratedProducts = products.filter(product => product.rating >= 2);
        }
        if (state.ratings === "1STARSABOVE") {
            ratedProducts = products.filter(product => product.rating >= 1);
        }
        return ratedProducts;
    }

    const filteredProductList = rating(sort(inStock(bestSeller(state.productList))));

    const value = {
        state,
        dispatch,
        products: filteredProductList,
        initialProductList,
    };

    return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};

export const useFilter = () => {
    const context = useContext(FilterContext);
    return context;
};
